<template>
<div class="wrap">
   <div class="title">城房案场-销售经理《隐私保护政策》</div>
   <div class="content">最近更新时间2021年12月。</div>
   <div class="content">如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</div>
   <div class="content">邮箱：hfcfb@hfcfb.cn；</div>
   <div class="content">日常办公地址：安徽省合肥市包河区未来塔B座36F</div>
   <div class="content text_">本政策将帮助您了解以下内容：</div> 
   <div class="content text_">我们如何收集和使用您的个人信息。</div>
   <div class="content text_">我们如何共享、转让、公开披露您的个人信息。</div>
   <div class="content text_">我们如何保护您的个人信息。</div>
   <div class="content text_">您的权利。</div>
   <div class="content text_">我们如何处理未成年人的个人信息。</div>
   <div class="content text_">您的个人信息如何在全球范围转移。</div>
   <div class="content text_">本政策如何更新。</div>
   <div class="content text_">如何联系我们。</div> 
   <div class="content">城房案场-销售经理平台（简称销售经理，以下简称销售经理）是由合肥城房宝数字科技有限公司开发的案场移动办公平台，我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，销售经理承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</div> 
   <div class="content">请在使用我们的产品（或服务）前，仔细阅读并了解本政策。</div> 
   <div class="content_title">一、我们如何收集和使用您的个人信息</div> 
   <div class="content">个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</div> 
   <div class="content">销售经理仅会出于本政策所述的以下目的，收集和使用您的个人信息：</div> 
   <div class="content text_">（一）您需授权我们收集和使用您的个人信息的情形</div> 
   <div class="content text_">1、注册成为用户。</div> 
   <div class="content">为完成创建账号，您需提供您的手机号码作为登录账号，并且销售经理会向您提供的手机号码发送短信验证码以确认是您本人注册。</div> 
   <div class="content text_">2、登录。</div> 
   <div class="content">为了您的账号安全，我们采用了单设备登陆方式的设计，登录时将会获取您的手机设备唯一码(IMEI)用来跟用户账号进行绑定，且需要启用读取手机状态权限。</div> 
   <div class="content text_">3、联系置业顾问</div>
   <div class="content">您可以在房源查询、锁定房源查询模块联系相关的置业顾问，此时我们需要申请拨打电话权限，如果您拒绝授权，将无法正常使用该功能，但不影响其他无需该权限的功能</div>
   <div class="content text_">4、更换个人头像</div>
   <div class="content">您可以更换个人头像，此时我们需要申请调用您的相机、相册、存储权限，如果您拒绝授权，将无法正常使用该功能，但不影响其他无需该权限的功能</div>
    <div class="content text_">5、日常办公</div> 
   <div class="content">为了您在客户端的相关操作记录可以作为企业参考标准依据，我们会接收并记录您所使用的设备相关信息，您所在企业组织分配给您的职位、隶属部门等信息，以及您完成企业组织经营管理开通的审批、审批记录信息等将作为企业控制数据。</div>
   <div class="content text_">6、运营与安全运行</div> 
   <div class="content">1）为了保障软件与服务的安全运行，改进及优化我们的服务体验以及保障您的账号安全，我们会收集您的硬件型号、操作系统版本号、软件版本号、设备品牌、设备型号、设备唯一识别码（如IMEI/MEID/androidID/IDFA/OPENUDID/IDFV/出厂序列号）、SIM卡IMSI信息、应用列表、屏幕分辨率、MAC地址、网络运营商信息、IP地址，以及操作、使用、服务日志。
2）为了预防恶意程序、保障软件的运行质量，我们会收集安装的应用信息或正在运行的进程信息、应用的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</div> 
   <div class="content text_">（二）使用到的第三方服务（SDK）</div> 
   <div class="content text_">1、阿里推送SDK</div> 
   <div class="content">作用：为向您及时通知本APP内的待审核订单，在您使用本APP时，我们会向您发送APP消息。我们需要读取您的手机状态和身份，以确保准确将信息发送给您。本APP不会将您的手机状态和身份用于其他目的。我们将根据您对功能的使用情况进行上述信息的收集。并可以在自己手机进行关闭。</div> 
   <div class="content">使用权限：写入外部存储、获取手机状态</div> 
   <div class="content text_">2、腾讯X5SDK</div> 
   <div class="content">作用：替代安卓原生webview，展示H5页面</div>
   <div class="content">收集数据：MAC地址、WLAN相关设备信息。</div>
   <div class="content">上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。</div> 
   <div class="content_title">二、我们如何共享、转让、公开披露您的个人信息</div> 
   <div class="content text_">（一）共享</div> 
   <div class="content">我们不会与城房集团以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</div> 
   <div class="content">1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</div> 
   <div class="content">2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</div> 
   <div class="content">3、与我们的附属公司共享：在获取明确同意的情况下，您的个人信息可能会与城房集团的附属公司共享。我们只会共享必要的个人信息，且受本个人信息保护政策中所声明目的的约束。附属公司如要改变个人信息的处理目的，将再次征求您的授权同意。</div> 
   <div class="content">4、与授权合作伙伴共享：仅为实现本政策中声明的目的，在获取明确同意的情况下，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</div> 
   <div class="content">对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</div> 
   <div class="content text_">（二）转让</div> 
   <div class="content">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</div> 
   <div class="content">1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</div> 
   <div class="content">2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</div> 
   <div class="content text_">（三）公开披露</div> 
   <div class="content">我们仅会在以下情况下，公开披露您的个人信息：</div> 
   <div class="content">1、获得您明确同意后；</div> 
   <div class="content">2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</div> 
   <div class="content_title">三、我们如何保护您的个人信息</div> 
   <div class="content">（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，我们会对数据进行加密；同时我们所访问服务器或浏览网页都是使用 https 安全方式；我们App会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</div> 
   <div class="content">（二）销售经理非常重视信息安全，成立了专门的负责团队。 我们努力为您提供信息保护，采取了合适的管理、技术以及物理安全措施，参照国内外信息安全标准及最佳实践建立了与业务发展相适应的信息安全保障体系。</div> 
   <div class="content">（三）我们对可能接触到您信息的员工也采取了严格管理，可监控他们的操作情况，对于数据访问、内外部传输使用、脱敏、解密等重要操作建立了审批机制，并与上述员工签署保密协议等。与此同时，我们还定期对员工进行信息安全培训，要求员工在日常工作中形成良好操作习惯，提升数据保护意识。我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</div> 
   <div class="content">（四）尽管有前述的安全措施，但同时也请您理解在网络上不存在“完善的安全措施”。我们会按现有的技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄露、损毁或丢失。</div> 
   <div class="content">（五）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</div> 
   <div class="content">同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</div> 
   <div class="content_title">四、您的权利</div> 
   <div class="content">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</div> 
   <div class="content">（一）访问您的个人信息</div> 
   <div class="content">您有权访问您的个人信息，法律法规规定的例外情况除外。</div> 
   <div class="content">（二）更正您的个人信息</div> 
   <div class="content">如果您希望访问或编辑更正您的账户中的个人资料信息，更改您的密码，您可以通过访问我的-设置执行此类操作。</div> 
   <div class="content">（三）删除您的个人信息</div> 
   <div class="content">在以下情形中，您可以向我们提出删除个人信息的请求：</div> 
   <div class="content">1、如果我们处理个人信息的行为违反法律法规；</div> 
   <div class="content">2、如果我们收集、使用您的个人信息，却未征得您的同意；</div> 
   <div class="content">3、如果我们处理个人信息的行为违反了与您的约定；</div> 
   <div class="content">4、如果您不再使用我们的产品或服务，或您注销了账号；</div> 
   <div class="content">5、如果我们不再为您提供产品或服务。</div> 
   <div class="content">若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</div> 
   <div class="content">当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</div> 
   <div class="content">（四）改变您授权同意的范围</div> 
   <div class="content">每个业务功能需要一些基本的个人信息才能得以完成（见本政策“第一部分”）。对于收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。</div> 
   <div class="content">（五）撤回同意收集个人信息及注销账户</div> 
   <div class="content">您随时可撤回向App提供的个人信息，可以通过邮箱与我们联系，我们会与您联系后对您的信息进行撤回收集，我们的邮箱地址是：hfcfb@hfcfb.cn。同时您也可以通过注销此注册账户的形式进行撤回同意收集个人信息，注销方式：进入【我的】-点击【关于我们】-点击最底部注销账户，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</div> 
   <div class="content">（六）约束信息系统自动决策</div> 
   <div class="content">在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</div> 
   <div class="content">（七）响应您的上述请求</div> 
   <div class="content">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求，我们将在三十天内做出答复。如您不满意，还可以通过本文首页所列明方式与我们联系。</div> 
   <div class="content">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</div> 
   <div class="content">在以下情形中，我们将无法响应您的请求：</div> 
   <div class="content">1、与个人信息控制者履行法律法规规定的义务相关的；</div> 
   <div class="content">2、与国家安全、国防安全直接相关的；</div> 
   <div class="content">3、与公共安全、公共卫生、重大公共利益直接相关的；</div> 
   <div class="content">4、与犯罪侦查、起诉、审判和执行判决等直接相关的；</div> 
   <div class="content">5、个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</div> 
   <div class="content">6、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div> 
   <div class="content">7、响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</div> 
   <div class="content">8、涉及商业秘密的。</div> 
   <div class="content_title">五、我们如何处理儿童的个人信息</div> 
   <div class="content">我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。</div> 
   <div class="content">对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</div> 
   <div class="content">尽管当地法律和习俗对儿童的定义不同，但我们将不满 16周岁的任何人均视为儿童。</div> 
   <div class="content">如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</div> 
   <div class="content_title">六、您的个人信息如何在全球范围转移</div> 
   <div class="content">原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。就中华人民共和国境外用户使用销售经理系统产品及服务过程中产生的个人信息，在符合所在国法律规定的前提下，您同意回传存储在国内的服务器上，否则您无法正常使用销售经理系统现有的产品及服务。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。</div> 
   <div class="content_title">七、本政策如何更新</div> 
   <div class="content">我们的个人信息保护政策可能变更。</div> 
   <div class="content">未经您明确同意，我们不会削减您按照本个人信息保护政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更，并在进入App时弹窗提示用户本协议更新。</div> 
   <div class="content">对于重大变更，我们还会提供更为显著的通知（包括对于某些服务， 我们会通过App或短信发送通知，说明个人信息保护政策的具体变更内容）。</div> 
   <div class="content">本政策所指的重大变更包括：</div> 
   <div class="content">1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div> 
   <div class="content">2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</div> 
   <div class="content">3、个人信息共享、转让或公开披露的主要对象发生变化；</div> 
   <div class="content">4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</div> 
   <div class="content">5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</div> 
   <div class="content">6、个人信息安全影响评估报告表明存在高风险时。</div> 
   <div class="content">我们还会将本政策的旧版本存档，供您查阅。</div> 
   <div class="content_title">八、如何联系我们</div> 
   <div class="content">如果您对本个人信息保护政策有任何疑问、意见或建议，可通过本文首页所列明方式与我们联系。</div> 
  </div>
</template>
<script>
export default {
    name: 'Privacy',
    data(){
        return{
            
        }
    }
}
</script>

<style lang="less" scoped>
  @import url(../assets/styles/common.css);
</style>